import React from 'react'
import Head from 'next/head'

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
        <link href="/play-cash-codebreakers/fonts/style.css" rel="stylesheet"/>
        <link href="/play-cash-codebreakers/errors/style.css" rel="stylesheet"/>
        <link rel="icon" type="image/ico" href='/play-cash-codebreakers/favicon.ico'/>
        <title>Cash Codebreakers: An Algebra Adventure</title>
      </Head>
      <Component {...pageProps} />
    </>
  )
}

export default MyApp
